import { Dialog } from 'quasar';
import { boot } from 'quasar/wrappers';
import SimUsageDialog from 'components/device/SimUsageDialog.vue';

export default boot(({ router }) => {
  router.afterEach((to) => {
    if (['accountDeviceSimUsage', 'accountlessDeviceSimUsage'].includes(<string>to.name)) {
      Dialog.create({
        component: SimUsageDialog,
        componentProps: {
          serial: to.params.serial,
        },
      });
    }
  });
});
